import EmailAuth from './EmailAuth';
import OTPAuth from './OTPAuth';

export const Email = EmailAuth;
export const OTP = OTPAuth;